import React from 'react';
import Lookup from '../componentes/select2';

const TipoVinculoFuncao = ({ clearable = false, ...props }) => {
  return (
    <Lookup
      clearable={clearable}
      labelKey="descricao"
      valueKey="id"
      url="/TipoVinculoFuncaoLookup"
      {...props}
    />
  );
};

export default TipoVinculoFuncao;
